// src/pages/CreateAccountPage.js
import React, { useContext, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../services/api";
import TopBanner from "../components/TopBanner";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { FaPencilAlt, FaCheck, FaStar } from "react-icons/fa";

function CreateAccountPage() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [loginForm, setLoginForm] = useState({
    identifier: "",
    name: "",
  });

  const [registerForm, setRegisterForm] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const [uiError, setUiError] = useState("");
  const [loading, setLoading] = useState(false);
const [loadingAction, setLoadingAction] = useState(null); // "login" | "register" | null

  const TEXT = {
    EN: {
      mainPage: "Main page",
      authentication: "Authentication",
      title: "AUTHENTICATION",

      loginTitle: "Logging",
      loginIdentifier: "Email or phone number",
      loginName: "Full name",
      signIn: "SIGN IN »",

      or: "OR",

      createTitle: "Create new account",
      fullName: "Full name",
      phone: "Phone number",
      emailOptional: "Email (optional)",
      register: "REGISTER »",

      whatGet: "what do you get?",
      trackOrder: "Possibility to track order status",
      orderHistory: "Access to order history",
      favourites: "Favourites",

      signingIn: "SIGNING IN...",
registering: "REGISTERING...",
      fillLogin: "Please enter email/phone and full name.",
      fillRegister: "Please enter full name and phone number.",
      phoneInvalid: "Phone number is invalid.",
    },
    AR: {
      mainPage: "الصفحة الرئيسية",
      authentication: "تسجيل الدخول",
      title: "تسجيل الدخول",
signingIn: "جارٍ تسجيل الدخول...",
registering: "جارٍ إنشاء الحساب...",
      loginTitle: "تسجيل الدخول",
      loginIdentifier: "البريد الإلكتروني أو رقم الهاتف",
      loginName: "الاسم الكامل",
      signIn: "تسجيل الدخول »",

      or: "أو",

      createTitle: "إنشاء حساب جديد",
      fullName: "الاسم الكامل",
      phone: "رقم الهاتف",
      emailOptional: "البريد الإلكتروني (اختياري)",
      register: "إنشاء حساب »",

      whatGet: "ماذا ستحصل؟",
      trackOrder: "إمكانية تتبع حالة الطلب",
      orderHistory: "الوصول إلى سجل الطلبات",
      favourites: "المفضلة",

      fillLogin: "يرجى إدخال البريد/الهاتف والاسم الكامل.",
      fillRegister: "يرجى إدخال الاسم الكامل ورقم الهاتف.",
      phoneInvalid: "رقم الهاتف غير صحيح.",
    },
  }[lang];

  const formatLbLocal = (digits) => {
    const d = digits.slice(0, 8);
    const p1 = d.slice(0, 2);
    const p2 = d.slice(2, 5);
    const p3 = d.slice(5, 8);
    return [p1, p2, p3].filter(Boolean).join(" ");
  };

  const formatLbPlus961 = (digitsAfter961) => {
    const d = digitsAfter961.slice(0, 8);
    const p1 = d.slice(0, 2);
    const p2 = d.slice(2, 5);
    const p3 = d.slice(5, 8);
    const parts = [p1, p2, p3].filter(Boolean).join(" ");
    return parts ? `+961 ${parts}` : "+961";
  };

  const formatPhoneInput = (raw) => {
    const v = (raw || "").trim();

    if (v.startsWith("+961")) {
      const after = v.replace(/\s/g, "").slice(4);
      const digits = after.replace(/\D/g, "");
      return formatLbPlus961(digits);
    }

    const compact = v.replace(/\s/g, "");
    const firstChar = compact.charAt(0);

    if (firstChar === "0" || firstChar === "7" || firstChar === "8") {
      const digits = v.replace(/\D/g, "").slice(0, 8);
      return formatLbLocal(digits);
    }

    return raw;
  };

  const formatLoginIdentifierInput = (raw) => {
  const value = raw || "";

  // Keep emails untouched
  if (value.includes("@")) {
    return value;
  }

  // Keep text untouched until it clearly looks like a Lebanese phone
  const compact = value.replace(/\s/g, "");

  if (
    compact.startsWith("+961") ||
    compact.startsWith("961") ||
    compact.startsWith("0") ||
    compact.startsWith("7") ||
    compact.startsWith("8")
  ) {
    if (compact.startsWith("961") && !compact.startsWith("+961")) {
      return formatLbPlus961(compact.slice(3).replace(/\D/g, ""));
    }

    return formatPhoneInput(value);
  }

  return value;
};

  const validatePhone = (value) => {
    const v = (value || "").trim();

    if (v.startsWith("+961")) {
      const all = v.replace(/\s/g, "");
      const after = all.slice(4);
      const digits = after.replace(/\D/g, "");
      return digits.length === 8;
    }

    const compact = v.replace(/\s/g, "");
    const firstChar = compact.charAt(0);

    if (firstChar === "0" || firstChar === "7" || firstChar === "8") {
      const digits = compact.replace(/\D/g, "");
      return digits.length === 8;
    }

    return true;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;
    setUiError("");

    if (!loginForm.identifier.trim() || !loginForm.name.trim()) {
      setUiError(TEXT.fillLogin);
      return;
    }

    try {
  setLoading(true);
  setLoadingAction("login");

      const res = await apiRequest("/auth/login", {
        method: "POST",
        body: JSON.stringify({
          identifier: loginForm.identifier,
          full_name: loginForm.name,
        }),
      });

      localStorage.setItem("esill-token", res.token);

      await apiRequest("/analytics/track", {
        method: "POST",
        body: JSON.stringify({
          action_type: "login_sync",
        }),
      }).catch(() => {});

      window.dispatchEvent(new Event("auth-changed"));
navigate("/");
    } catch (err) {
      setUiError(err.message);
    } finally {
      setLoading(false);
setLoadingAction(null);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (loading) return;
    setUiError("");

    if (!registerForm.name.trim() || !registerForm.phone.trim()) {
      setUiError(TEXT.fillRegister);
      return;
    }

    if (!validatePhone(registerForm.phone)) {
      setUiError(TEXT.phoneInvalid);
      return;
    }

    try {
  setLoading(true);
  setLoadingAction("register");

      const res = await apiRequest("/auth/register", {
        method: "POST",
        body: JSON.stringify({
          full_name: registerForm.name,
          phone: registerForm.phone,
          email: registerForm.email || null,
        }),
      });

      localStorage.setItem("esill-token", res.token);

      await apiRequest("/analytics/track", {
        method: "POST",
        body: JSON.stringify({
          action_type: "auth_sync",
        }),
      }).catch(() => {});

      const sessionToken = localStorage.getItem("esill-session");

      if (sessionToken) {
        await apiRequest("/cart/merge", {
          method: "POST",
          body: JSON.stringify({ session_token: sessionToken }),
        }).catch(() => {});
      }

      window.dispatchEvent(new Event("auth-changed"));
navigate("/");
    } catch (err) {
      setUiError(err.message);
    } finally {
      setLoading(false);
setLoadingAction(null);
    }
  };

  const inputClass = `
    w-full
    h-11
    border border-gray-400
    bg-white
    px-3
    text-sm
    outline-none
    focus:border-black
    transition
    disabled:bg-gray-100
    disabled:text-gray-500
    disabled:cursor-wait
  `;

  const labelClass = "block text-[12px] font-medium text-gray-900 mb-1";

  const outlineButtonClass = `
  w-full
  h-11
  rounded-md
  border border-black border-[2px]
  bg-white
  text-gray-900
  text-sm font-semibold tracking-wide
  hover:bg-black hover:text-white
  active:scale-[0.99]
  transition
  disabled:opacity-60
  disabled:cursor-wait
  disabled:hover:bg-white
  disabled:hover:text-gray-900
`;

  const BenefitItem = ({ icon, text }) => (
  <div className="flex items-center justify-center gap-3 text-sm text-gray-900 text-center">
    <span className="w-8 h-8 border border-gray-300 rounded-md flex items-center justify-center shrink-0">
      {icon}
    </span>
    <span>{text}</span>
  </div>
);

  return (
    <div
  className="w-full min-h-screen bg-[#F6EFE9] overflow-x-hidden"
  dir={lang === "AR" ? "rtl" : "ltr"}
>
      <TopBanner />
      <MainHeader />

      <main className="bg-[#F6EFE9] px-4 md:px-8  md:pt-[170px]">
        {/* BREADCRUMB */}
        <div className="text-[12px] md:text-sm text-gray-900 mb-6">
          <button
  type="button"
  onClick={() => navigate("/")}
  className="hover:text-black hover:underline"
>
  {TEXT.mainPage}
</button>

          <span className="mx-2">›</span>

          <span className="text-gray-900">{TEXT.authentication}</span>
        </div>

        {/* TITLE */}
        <div className="text-left mb-2">
          <h1 className="text-[16px] md:text-[20px] font-normal tracking-wide text-gray-900 uppercase">
            {TEXT.title}
          </h1>
        </div>

        {/* THICK LINE */}
        <div className="h-[1px] bg-gray-300 mx-1 md:mx-4 mb-8" />

        {/* ERROR */}
        {uiError && (
  <div
    className="
      max-w-5xl mx-auto mb-5
      border border-red-200
      bg-red-50
      text-red-700
      text-sm
      px-4 py-3
      rounded-md
      flex items-start gap-2
    "
  >
    <span className="font-bold leading-5">!</span>
    <span>{uiError}</span>
  </div>
)}

        {/* CONTENT */}
        <div className="max-w-6xl mx-auto">
          {/* MOBILE */}
          <div className="md:hidden">
            {/* LOGIN */}
            <section className="pb-7">
              <h2 className="text-center text-[18px] font-normal text-gray-900 mb-6">
                {TEXT.loginTitle}
              </h2>

              <form onSubmit={handleLogin} className="space-y-4">
                <div>
                  <label className={labelClass}>{TEXT.loginIdentifier}</label>
                  <input
  disabled={loading}
  className={inputClass}
  value={loginForm.identifier}
  onChange={(e) =>
    setLoginForm((prev) => ({
      ...prev,
      identifier: formatLoginIdentifierInput(e.target.value),
    }))
  }
/>
                </div>

                <div>
                  <label className={labelClass}>{TEXT.loginName}</label>
                  <input
  disabled={loading}
  className={inputClass}
  value={loginForm.name}
  onChange={(e) =>
    setLoginForm((prev) => ({
      ...prev,
      name: e.target.value,
    }))
  }
/>
                </div>

                <button
  type="submit"
  disabled={loading}
  className={outlineButtonClass}
>
  {loadingAction === "login" ? TEXT.signingIn : TEXT.signIn}
</button>
              </form>
            </section>

            <div className="text-center font-bold text-gray-900 mb-7">
              {TEXT.or}
            </div>

            {/* REGISTER */}
            <section className="pb-7">
              <h2 className="text-center text-[18px] font-normal text-gray-900 mb-6">
                {TEXT.createTitle}
              </h2>

              <form onSubmit={handleRegister} className="space-y-4">
                <div>
                  <label className={labelClass}>{TEXT.fullName}</label>
                  <input
  disabled={loading}
  className={inputClass}
  value={registerForm.name}
  onChange={(e) =>
    setRegisterForm((prev) => ({
      ...prev,
      name: e.target.value,
    }))
  }
/>
                </div>

                <div>
                  <label className={labelClass}>{TEXT.phone}</label>
                  <input
  disabled={loading}
  className={inputClass}
  value={registerForm.phone}
  onChange={(e) =>
    setRegisterForm((prev) => ({
      ...prev,
      phone: formatPhoneInput(e.target.value),
    }))
  }
/>
                </div>

                <div>
                  <label className={labelClass}>{TEXT.emailOptional}</label>
                  <input
  disabled={loading}
  type="email"
  className={inputClass}
  value={registerForm.email}
  onChange={(e) =>
    setRegisterForm((prev) => ({
      ...prev,
      email: e.target.value,
    }))
  }
/>
                </div>

                <button
  type="submit"
  disabled={loading}
  className={outlineButtonClass}
>
  {loadingAction === "register" ? TEXT.registering : TEXT.register}
</button>
              </form>
            </section>

            {/* BENEFITS */}
            <section className="pb-0">
              <h3 className="text-center font-bold text-gray-900 mb-5">
                {TEXT.whatGet}
              </h3>

              <div className="space-y-3 flex flex-col items-center">
                <BenefitItem
                  icon={<FaPencilAlt className="text-[13px] text-gray-900" />}
                  text={TEXT.trackOrder}
                />

                <BenefitItem
                  icon={<FaCheck className="text-[13px] text-gray-900" />}
                  text={TEXT.orderHistory}
                />

                <BenefitItem
                  icon={<FaStar className="text-[16px] text-gray-900" />}
                  text={TEXT.favourites}
                />
              </div>
            </section>
          </div>

          {/* DESKTOP */}
          <div className="hidden md:grid grid-cols-[1fr_1px_1fr] gap-10 pb-12">
            {/* LOGIN COLUMN */}
            <section>
              <h2 className="text-center text-[20px] font-normal text-gray-900 mb-8">
                {TEXT.loginTitle}
              </h2>

              <form onSubmit={handleLogin} className="space-y-5 max-w-md mx-auto">
                <div>
                  <label className={labelClass}>{TEXT.loginIdentifier}</label>
                  <input
  disabled={loading}
  className={inputClass}
  value={loginForm.identifier}
  onChange={(e) =>
    setLoginForm((prev) => ({
      ...prev,
      identifier: formatLoginIdentifierInput(e.target.value),
    }))
  }
/>
                </div>

                <div>
                  <label className={labelClass}>{TEXT.loginName}</label>
                  <input
  disabled={loading}
  className={inputClass}
  value={loginForm.name}
  onChange={(e) =>
    setLoginForm((prev) => ({
      ...prev,
      name: e.target.value,
    }))
  }
/>
                </div>

                <button
  type="submit"
  disabled={loading}
  className={outlineButtonClass}
>
  {loadingAction === "login" ? TEXT.signingIn : TEXT.signIn}
</button>
              </form>
            </section>

            {/* VERTICAL LINE */}
            <div className="bg-gray-300 w-px min-h-[360px]" />

            {/* REGISTER COLUMN */}
            <section>
              <h2 className="text-center text-[20px] font-normal text-gray-900 mb-8">
                {TEXT.createTitle}
              </h2>

              <form onSubmit={handleRegister} className="space-y-5 max-w-md mx-auto">
                <div>
                  <label className={labelClass}>{TEXT.fullName}</label>
                  <input
  disabled={loading}
  className={inputClass}
  value={registerForm.name}
  onChange={(e) =>
    setRegisterForm((prev) => ({
      ...prev,
      name: e.target.value,
    }))
  }
/>
                </div>

                <div>
                  <label className={labelClass}>{TEXT.phone}</label>
                  <input
  disabled={loading}
  className={inputClass}
  value={registerForm.phone}
  onChange={(e) =>
    setRegisterForm((prev) => ({
      ...prev,
      phone: formatPhoneInput(e.target.value),
    }))
  }
/>
                </div>

                <div>
                  <label className={labelClass}>{TEXT.emailOptional}</label>
                  <input
  disabled={loading}
  type="email"
  className={inputClass}
  value={registerForm.email}
  onChange={(e) =>
    setRegisterForm((prev) => ({
      ...prev,
      email: e.target.value,
    }))
  }
/>
                </div>

                <button
  type="submit"
  disabled={loading}
  className={outlineButtonClass}
>
  {loadingAction === "register" ? TEXT.registering : TEXT.register}
</button>
              </form>

              <div className="max-w-md mx-auto mt-9">
                <h3 className="text-center font-bold text-gray-900 mb-5">
                  {TEXT.whatGet}
                </h3>

                <div className="space-y-3 flex flex-col items-center">
                  <BenefitItem
                    icon={<FaPencilAlt className="text-[13px] text-gray-900" />}
                    text={TEXT.trackOrder}
                  />

                  <BenefitItem
                    icon={<FaCheck className="text-[13px] text-gray-900" />}
                    text={TEXT.orderHistory}
                  />

                  <BenefitItem
                    icon={<FaStar className="text-[16px] text-gray-900" />}
                    text={TEXT.favourites}
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default CreateAccountPage;